<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fill-rule="evenodd">
      <g>
        <g>
          <g>
            <g>
              <g>
                <g>
                  <path fill="#E1F5FE" d="M1.589 1.312H20.589V13.312H1.589z" transform="translate(-157 -672) translate(127 490) translate(16 66) translate(0 50) translate(14 66) translate(1 5)" />
                  <path fill="#164194" d="M0 14.667h22V0H0v14.667zm1.833-1.833h18.334v-11H1.833v11z" transform="translate(-157 -672) translate(127 490) translate(16 66) translate(0 50) translate(14 66) translate(1 5)" />
                  <path
                    fill="#13A2E8"
                    d="M11 5.5c-1.012 0-1.833.821-1.833 1.833S9.988 9.167 11 9.167s1.833-.822 1.833-1.834S12.012 5.5 11 5.5m0 5.5c-2.025 0-3.667-1.642-3.667-3.667S8.975 3.667 11 3.667s3.667 1.641 3.667 3.666S13.025 11 11 11M16.5 8.25L18.333 8.25 18.333 6.417 16.5 6.417zM3.667 8.25L5.5 8.25 5.5 6.417 3.667 6.417z"
                    transform="translate(-157 -672) translate(127 490) translate(16 66) translate(0 50) translate(14 66) translate(1 5)"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>